const etravBooking = (
	location,
	response,
	invoice,
	dispatch,
	agentInfo,
	fareQuoteEtrav,
	payment,
	FlightBookEtravDispatch,
	history,
	FlightTicketLCCDispatch,
	FlightBookDispatch
) => {
	let formEtrav = {
		Customer_Mobile: location.state.formData.phone,
		Passenger_Mobile: location.state.formData.phone,
		orderId: location.state.orderID,
		paymentId: response === 'success' ? invoice : response.razorpay_payment_id,
		WhatsAPP_Mobile: null,
		Passenger_Email: location.state.formData
			? location.state.formData.email
			: '',
		PAX_Details: location.state.BookingData.map((item, index) => {
			return {
				Pax_Id: index + 1,
				Pax_type: item.PaxType - 1,
				Title: item.title,
				First_Name: item.first_name,
				Last_Name: item.last_name,
				Gender: 0,
				Age: null,
				DOB: item.dob,
				Passport_Number: null,
				Passport_Issuing_Country: null,
				Passport_Expiry: null,
				Nationality: null,
				FrequentFlyerDetails: null,
			};
		}),

		GST: true,
		GST_Number: '',
		GST_HolderName: 'GST Holder Name',
		GST_Address: 'GST Address',
		BookingFlightDetails: [
			{
				Search_Key: location.state.IDEtrav,
				Flight_Key:
					fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
				BookingSSRDetails: [],
			},
		],
		CostCenterId: 0,
		ProjectId: 0,
		BookingRemark: '',
		CorporateStatus: 0,
		CorporatePaymentMode: 0,
		MissedSavingReason: null,
		CorpTripType: null,
		CorpTripSubType: null,
		TripRequestId: null,
		BookingAlertIds: null,
	};
	dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// if (location.state.OneflightData.Airline_Code) {
	// 	const SPA1 = {
	// 		Pax_Id: 1,
	// 		Pax_type: 0,
	// 		Title: location.state.formData ? location.state.formData.titleA1 : '',
	// 		First_Name: location.state.formData
	// 			? location.state.formData.first_nameA1
	// 			: '',
	// 		Last_Name: location.state.formData
	// 			? location.state.formData.last_nameA1
	// 			: '',
	// 		Gender: 0,
	// 		Age: null,
	// 		DOB: null,
	// 		Passport_Number: null,
	// 		Passport_Issuing_Country: null,
	// 		Passport_Expiry: null,
	// 		Nationality: null,
	// 		FrequentFlyerDetails: null,
	// 	};
	// 	if (location.state.body.AdultCount === 1) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			orderId: location.state.orderID,
	// 			paymentId:
	// 				response === 'success' ? invoice : response.razorpay_payment_id,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [SPA1],

	// 			GST: true,
	// 			GST_Number: '',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: '',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('FormData', formEtrav);
	// 		// let child1 = {
	// 		// 	Customer_Mobile: location.state.formData.phone,
	// 		// 	Passenger_Mobile: location.state.formData.phone,
	// 		// 	orderId: location.state.orderID,
	// 		// 	paymentId:
	// 		// 		response === 'success' ? invoice : response.razorpay_payment_id,
	// 		// 	WhatsAPP_Mobile: null,
	// 		// 	Passenger_Email: location.state.formData
	// 		// 		? location.state.formData.email
	// 		// 		: '',
	// 		// 	PAX_Details: [
	// 		// 		{
	// 		// 			Pax_Id: 1,
	// 		// 			Pax_type: 0,
	// 		// 			Title: location.state.formData
	// 		// 				? location.state.formData.titleA1
	// 		// 				: '',
	// 		// 			First_Name: location.state.formData
	// 		// 				? location.state.formData.first_nameA1
	// 		// 				: '',
	// 		// 			Last_Name: location.state.formData
	// 		// 				? location.state.formData.last_nameA1
	// 		// 				: '',
	// 		// 			Gender: 0,
	// 		// 			Age: null,
	// 		// 			DOB: null,
	// 		// 			Passport_Number: null,
	// 		// 			Passport_Issuing_Country: null,
	// 		// 			Passport_Expiry: null,
	// 		// 			Nationality: null,
	// 		// 			FrequentFlyerDetails: null,
	// 		// 		},
	// 		// 		{
	// 		// 			Pax_Id: 2,
	// 		// 			Pax_type: 1,
	// 		// 			Title: location.state.formData
	// 		// 				? location.state.formData.titleC1
	// 		// 				: '',
	// 		// 			First_Name: location.state.formData
	// 		// 				? location.state.formData.first_nameC1
	// 		// 				: '',
	// 		// 			Last_Name: location.state.formData
	// 		// 				? location.state.formData.last_nameC1
	// 		// 				: '',
	// 		// 			Gender: 0,
	// 		// 			Age: null,
	// 		// 			DOB: null,
	// 		// 			Passport_Number: null,
	// 		// 			Passport_Issuing_Country: null,
	// 		// 			Passport_Expiry: null,
	// 		// 			Nationality: null,
	// 		// 			FrequentFlyerDetails: null,
	// 		// 		},
	// 		// 	],

	// 		// 	GST: true,
	// 		// 	GST_Number: '',
	// 		// 	GST_HolderName: 'GST Holder Name',
	// 		// 	GST_Address: 'GST Address',
	// 		// 	BookingFlightDetails: [
	// 		// 		{
	// 		// 			Search_Key: location.state.IDEtrav,
	// 		// 			Flight_Key:
	// 		// 				fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 		// 			BookingSSRDetails: [],
	// 		// 		},
	// 		// 	],
	// 		// 	CostCenterId: 0,
	// 		// 	ProjectId: 0,
	// 		// 	BookingRemark: '',
	// 		// 	CorporateStatus: 0,
	// 		// 	CorporatePaymentMode: 0,
	// 		// 	MissedSavingReason: null,
	// 		// 	CorpTripType: null,
	// 		// 	CorpTripSubType: null,
	// 		// 	TripRequestId: null,
	// 		// 	BookingAlertIds: null,
	// 		// };
	// 		// console.log('formEtrav', formEtrav);
	// 		// if (location.state.body.ChildCount === 1) {
	// 		// 	dispatch(
	// 		// 		FlightBookEtravDispatch(
	// 		// 			child1,
	// 		// 			history,
	// 		// 			payment,
	// 		// 			location.state,
	// 		// 			agentInfo
	// 		// 		)
	// 		// 	);
	// 		// } else {
	// 		// 	dispatch(
	// 		// 		FlightBookEtravDispatch(
	// 		// 			formEtrav,
	// 		// 			history,
	// 		// 			payment,
	// 		// 			location.state,
	// 		// 			agentInfo
	// 		// 		)
	// 		// 	);
	// 		// }
	// 	} else if (location.state.body.AdultCount === 2) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			orderId: location.state.orderID,
	// 			paymentId:
	// 				response === 'success' ? invoice : response.razorpay_payment_id,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [
	// 				{
	// 					Pax_Id: 1,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 2,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 			],

	// 			GST: true,
	// 			GST_Number: '',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: '',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('formEtrav', formEtrav);
	// 		dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// 	} else if (location.state.body.AdultCount === 3) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [
	// 				{
	// 					Pax_Id: 1,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 2,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 3,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA3
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA3
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA3
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 			],

	// 			GST: true,
	// 			GST_Number: '',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('formEtrav', formEtrav);
	// 		dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// 	} else if (location.state.body.AdultCount === 4) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [
	// 				{
	// 					Pax_Id: 1,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 2,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 3,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA3
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA3
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA3
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 4,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA4
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA4
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA4
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 			],

	// 			GST: true,
	// 			GST_Number: '29AADCB2230M1ZP',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
	// 						// },
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
	// 						// },
	// 					],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('formEtrav', formEtrav);
	// 		dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// 	} else if (location.state.body.AdultCount === 5) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [
	// 				{
	// 					Pax_Id: 1,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 2,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 3,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA3
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA3
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA3
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 4,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA4
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA4
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA4
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 5,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA5
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA5
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA5
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 			],

	// 			GST: true,
	// 			GST_Number: '29AADCB2230M1ZP',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
	// 						// },
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
	// 						// },
	// 					],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('formEtrav', formEtrav);
	// 		dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// 	} else if (location.state.body.AdultCount === 6) {
	// 		let formEtrav = {
	// 			Customer_Mobile: location.state.formData.phone,
	// 			Passenger_Mobile: location.state.formData.phone,
	// 			WhatsAPP_Mobile: null,
	// 			Passenger_Email: location.state.formData
	// 				? location.state.formData.email
	// 				: '',
	// 			PAX_Details: [
	// 				{
	// 					Pax_Id: 1,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 2,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 3,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA3
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA3
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA3
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 4,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA4
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA4
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA4
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 5,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA5
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA5
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA5
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 				{
	// 					Pax_Id: 6,
	// 					Pax_type: 0,
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA6
	// 						: '',
	// 					First_Name: location.state.formData
	// 						? location.state.formData.first_nameA6
	// 						: '',
	// 					Last_Name: location.state.formData
	// 						? location.state.formData.last_nameA6
	// 						: '',
	// 					Gender: 0,
	// 					Age: null,
	// 					DOB: null,
	// 					Passport_Number: null,
	// 					Passport_Issuing_Country: null,
	// 					Passport_Expiry: null,
	// 					Nationality: null,
	// 					FrequentFlyerDetails: null,
	// 				},
	// 			],

	// 			GST: true,
	// 			GST_Number: '29AADCB2230M1ZP',
	// 			GST_HolderName: 'GST Holder Name',
	// 			GST_Address: 'GST Address',
	// 			BookingFlightDetails: [
	// 				{
	// 					Search_Key: location.state.IDEtrav,
	// 					Flight_Key:
	// 						fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
	// 					BookingSSRDetails: [
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
	// 						// },
	// 						// {
	// 						// 	Pax_Id: 1,
	// 						// 	SSR_Key:
	// 						// 		'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
	// 						// },
	// 					],
	// 				},
	// 			],
	// 			CostCenterId: 0,
	// 			ProjectId: 0,
	// 			BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
	// 			CorporateStatus: 0,
	// 			CorporatePaymentMode: 0,
	// 			MissedSavingReason: null,
	// 			CorpTripType: null,
	// 			CorpTripSubType: null,
	// 			TripRequestId: null,
	// 			BookingAlertIds: null,
	// 		};
	// 		console.log('formEtrav', formEtrav);
	// 		dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
	// 	}
	// }
};

export default etravBooking;
